/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import config from "../../../config/config";
import { useSelector } from "react-redux";
import { usePopupManager } from "../../../providers/PopupManager/PopupManager";
import { MESSAGE_TYPE } from "../../../constants";
import axios from "axios";

import DashboardSection from "../../DashboardContainer/DashboardSection";
import TrademarkBarChart from "../../TrademarkBarChart/TrademarkBarChart";
import LegalPieChart from "../../LegalPieChart/LegalPieChart";
import ComplaintDisputeChart from "../../ComplaintDisputeChart/ComplaintDisputeChart";
import ComplaintDisputeBarChart from "../../ComplaintDisputeChart/ComplaintBarChart";
import DomainTile from "../../DomainTile/DomainTile";
import styles from "./MainDashboard.module.css";
import "./MainDashboard.css";
import RecordToReportPieChart from "../RecordToReportPieChart/RecordToReportPieChart";
import RecordToReportBarChart from "../RecordToReportBarChart/RecordToReportBarChart";
import RecordToReportSingleBar from "../RecordToReportSingleBar/RecordToReportSingleBar";
import ReportsStatusBarChart from "../ReportsStatusBarChart/ReportsStatusBarChart";
import DetailedDomainTile from "../../../atomicComponents/DetailedDomainTile/DetailedDomainTile";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import TrendIndicator from "../RecordToReportTrendIndicator/RecordToReportTrendIndicator";
import R2RLineChart from "../R2RComponent/R2RLineChart";
import R2RMiniStat from "../R2RComponent/R2RMiniStat";
import R2RTileComp from "../R2RTileComp/R2RTileComp";
import reconciledimg from "../R2RIcons/reconciledimg.png"
import reconvolumne from "../R2RIcons/reconvolume.png"
import ageunreconitems from "../R2RIcons/ageunreconitems.png"
import unreconciledvalue from "../R2RIcons/unreconciledvalue.png"
import R2RDomainTile from "../R2RDomainTile/R2RDomainTile";
import RecordBarChart from "../RecordToReportBarChart/RecordBarChart";

const WeekOptions = [
  { value: "undefined", label: "Select" },
  { value: "All", label: "-All-" },
  ...Array.from({ length: 52 }, (_, i) => ({
    value: `W${i + 1}`,
    label: `Week ${i + 1}`,
  })),
];

const { API_BASE_URL } = config;

const RecordToReportMainDashboard = () => {
  const token = useSelector((state) => state.auth.djangoAccessToken);
  const roles = useSelector((state) => state.auth.djangoRoles);
  const userInfo = useSelector((state) => state.auth.djangoUserInfo);

  const location = useLocation();
  const { showPopup } = usePopupManager();

  const initialFilters = location.state || {
    entityData: null,
    subEntityData: [],
    yearData: null,
    monthData: [],
  };

  const [hasApplied, setHasApplied] = useState(false);

  const [filters, setFilters] = useState(initialFilters);

  const [showDashboard, setShowDashboard] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [entityOptions, setEntityOptions] = useState([]);
  const [subEntityOptions, setSubEntityOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [monthOptions, setMonthOptions] = useState([]);

  const [entity, setEntity] = useState(null);
  const [subEntity, setSubEntity] = useState([]);
  const [year, setYear] = useState(null);
  const [month, setMonth] = useState([]);

  const [week, setWeek] = useState(WeekOptions[0]);

  const [filedBy, setFiledBy] = useState(0);
  const [filedAgainst, setFiledAgainst] = useState(0);
  const [glLabels, setGLLabels] = useState([]);
  const [ageUnreconItemData, setAgeUnreconItemData] = useState({ labels: [], datasets: [], });
  const [ageUnreconMonthData, setAgeUnreconMonthData] = useState([]);
  const [ageMonthLabel, setAgeMonthLabel] = useState([]);

  const [avgAge, setAvgAge] = useState(0);
  const [changeAvgAgeText, setChangeAvgAgeText] = useState("");
  const [isIncAvgAge, setIsIncAvgAge] = useState(false);

  const [reconciledVol, setReconciledVol] = useState(0);
  const [changeVolText, setChangeVolText] = useState("");
  const [isIncVol, setIsIncVol] = useState(false);

  const [acReconciledValues, setACreconciledValue] = useState(0);
  const [changeText, setChangeText] = useState("");
  const [isIncrease, setIsIncrease] = useState(false);

  const [unReconciledValues, setUnreconciledValue] = useState(0);
  const [changeUnText, setChangeUnText] = useState("");
  const [isIncDec, setIsIncdec] = useState(false);

  const [gritData, setGritData] = useState({ grit_score: 0, rank: 0 });
  const [epmData, setEpmData] = useState({ epm_score: 0 });
  const [disclosureData, setDisclosureData] = useState({ delayed: 0, on_time: 0, });
  const [agedUnreconciledVarianceData, setAgedUnreconciledVarianceData] = useState({ labels: [], datasets: [] });
  const [ageUnreconConsecutive, setAgeUnreconConsecutive] = useState({ labels: [], datasets: [] });

  const history = useHistory();

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "20px",
      flexWrap: "wrap",
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: "50px",
      overflowY: "auto",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      overflow: "visible",
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "200px",
      overflowY: "auto",
      overflowX: "auto",
      whiteSpace: "nowrap",
    }),
    option: (provided) => ({
      ...provided,
      padding: "8px 12px",
    }),
  };

  const handleEntityChange = (selected) => {
    setEntity(selected);
    setFilters((prev) => ({ ...prev, entityData: selected }));
  };

  const handleSubEntityChange = (selected) => {
    const updatedSubEntity = selected || [];
    setSubEntity(updatedSubEntity);
    setFilters((prev) => ({ ...prev, subEntityData: updatedSubEntity }));
  };

  const handleYearChange = (selected) => {
    setYear(selected);
    setFilters((prev) => ({ ...prev, yearData: selected }));
  };

  const handleMonthChange = (selected) => {
    const updatedMonths = selected || [];
    setMonth(updatedMonths);
    setFilters((prev) => ({ ...prev, monthData: updatedMonths }));
  };

  const handleWeekChange = (selected) => {
    setWeek(selected);
    setFilters((prev) => ({ ...prev, weekData: selected }));
  };

  const handleApply = () => {
    const entityFilterData = entity?.value || "";
    const subEntityFilterData = subEntity?.map((s) => s?.value) || [];
    const yearFilterData = year?.value || "";
    const monthFilterData = month?.map((m) => m?.value) || [];

    if (entityFilterData === "") {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select entity.",
      });
      return;
    }

    if (yearFilterData === "") {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select year.",
      });
      return;
    }

    setIsLoading(true);

    if (entity?.value?.toUpperCase().includes("JLR")) {
      history.push("/Record-To-Report/JLR", filters);
      return;
    } else if (entity?.value?.toUpperCase().includes("AGRATAS")) {
      history.push("/Record-To-Report/Agratas",{yearData: [year],monthData:month});
      return;
    } else {
      history.push("/Record-To-Report", filters);
    }

    const fetchGLCoverageData = async () => {
      try {
        const response = await axios
          .post(
            `${API_BASE_URL}/api/R2R-glcoverage`,
            {
              selectedEntity: entityFilterData,
              selectedYear: yearFilterData,
              selectedMonth: monthFilterData,
            },
            {
              headers: {
                // Authorization: `Bearer ${token}`,
                Authorization: "Basic YWRtaW4xOjEyMw==",
              },
            }
          )
          .then((response) => {
            const result = response.data;
            if (result && result.gl_coverage && result.gl_coverage.length > 0) {
              const labels = result.gl_coverage.map((item) => item.gdc_non_gdc);
              const values = result.gl_coverage.map(
                (item) => item.percentage_share
              );
              setGLLabels(labels);
              setFiledBy(values[0] || 0);
              setFiledAgainst(values[1] || 0);
            } else {
              setGLLabels(["GDC", "Non GDC"]);
              setFiledBy(0);
              setFiledAgainst(0);
            }
          });
      } catch (error) {
        console.error("Error fetching R2R GL Coverage Data options:", error);
      }
    };

    const fetchAgeUnreconItemData = async () => {
      try {
        const response = await axios.post(
          `${API_BASE_URL}/api/R2R-age-unreconitem`,
          {
            selectedEntity: entityFilterData,
            selectedYear: yearFilterData,
            selectedMonth: monthFilterData,
          },
          {
            headers: {
              Authorization: "Basic YWRtaW4xOjEyMw=="
            },
          }
        );

        const result = response.data?.AgedUnreconciledItems || [];
        const desiredLabels = ["0-3 Days", "3-7 Days", ">7 Days"];

        const dataMap = result.reduce((acc, item) => {
          acc[item.bucket] = {
            count: item.total_age_count,
            amount: item.total_amount_lc,
          };
          return acc;
        }, {});

        const countData = desiredLabels.map((label) => dataMap[label]?.count || 0);
        const amountData = desiredLabels.map((label) => dataMap[label]?.amount || 0);

        const datasets = [
          {
            label: "Count",
            data: countData,
            backgroundColor: "#4e8ef6"
          },
          {
            label: "Amount (In Crores)",
            data: amountData,
            backgroundColor: "#f5a722",
          },
        ];

        setAgeUnreconItemData({ labels: desiredLabels, datasets });

      } catch (error) {
        console.error(
          "Error fetching R2R Aged Unreconciled Item options:",
          error
        );
        setAgeUnreconItemData({
          labels: ["0-3 Days", "3-7 Days", ">7 Days"],
          datasets: [
            { label: "Count", data: [0, 0, 0], backgroundColor: "#2f78c4" },
            { label: "Amount (In Crores)", data: [0, 0, 0], backgroundColor: "#f4a300" },
          ],
        });
      }
    };

    const fetchAgeUnreconMonthItemData = async () => {
      try {
        const response = await axios
          .post(
            `${API_BASE_URL}/api/R2R-age-unreconmonth`,
            {
              selectedEntity: entityFilterData,
              selectedYear: yearFilterData,
              selectedMonth: monthFilterData,
            },
            {
              headers: {
                // Authorization: `Bearer ${token}`,
                Authorization: "Basic YWRtaW4xOjEyMw==",
              },
            }
          )
          .then((response) => {
            const result = response.data.AgedUnreconciledItemsMonthEnd;
            const AgedUnreconciledItemsMonthEnd = [
              {
                label: [""],
                data: [result.total_age_count, result.total_amount_lc],
                backgroundColor: ["#4e8ef6", "#f5a722"],
              },
            ];
            setAgeMonthLabel(["Count", "Amount (In Cr)"])
            setAgeUnreconMonthData(AgedUnreconciledItemsMonthEnd);
          });
      } catch (error) {
        console.error(
          "Error fetching R2R Aged Unreconciled Item - Month End Data options:",
          error
        );
      }
    };


    const fetchR2RAvgage = async () => {
      let allPreviousMonth = [];
      monthFilterData.forEach((item) => {
        if (item - 1 !== 0) allPreviousMonth.push(item - 1);
      });
      try {
        const response = await axios
          .post(
            `${API_BASE_URL}/api/R2R-averageage`,
            {
              selectedEntity: entityFilterData,
              selectedYear: yearFilterData,
              selectedMonth: monthFilterData,
              previousMonth: allPreviousMonth,
            },
            {
              headers: {
                // Authorization: `Bearer ${token}`,
                Authorization: "Basic YWRtaW4xOjEyMw==",
              },
            }
          )
          .then((response) => {
            const result = response.data;

            const currentValue = result.current_month_value || 0;
            const previousValue = result.previous_month_value || 0;

            setAvgAge(currentValue);

            const change = currentValue - previousValue;

            if (change === 0) {
              setChangeAvgAgeText("0 Days Change MoM");
              setIsIncAvgAge(false);
            } else if (change > 0) {
              setChangeAvgAgeText(`${change} Days Increase MoM`);
              setIsIncAvgAge(true);
            } else {
              setChangeAvgAgeText(`${Math.abs(change)} Days Decrease MoM`);
              setIsIncAvgAge(false);
            }
          });
      } catch (error) {
        console.error(
          "Error fetching R2R Average Age Unreconciled Item Volume options:",
          error
        );
      }
    };

    const fetchR2RReconciledVolume = async () => {
      let allPreviousMonth = [];
      monthFilterData.forEach((item) => {
        if (item - 1 !== 0) allPreviousMonth.push(item - 1);
      });
      try {
        const response = await axios
          .post(
            `${API_BASE_URL}/api/R2R-reconciledvolume`,
            {
              selectedEntity: entityFilterData,
              selectedYear: yearFilterData,
              selectedMonth: monthFilterData,
              previousMonth: allPreviousMonth,
            },
            {
              headers: {
                // Authorization: `Bearer ${token}`,
                Authorization: "Basic YWRtaW4xOjEyMw==",
              },
            }
          )
          .then((response) => {
            const result = response.data;

            const currentValue = result.current_month_value || 0;
            const previousValue = result.previous_month_value || 0;

            setReconciledVol(currentValue);

            const change = currentValue - previousValue;

            if (change === 0) {
              setChangeVolText("No Change MoM");
              setIsIncVol(false);
            } else if (change > 0) {
              setChangeVolText(`${change} Increase MoM`);
              setIsIncVol(true);
            } else {
              setChangeVolText(`${Math.abs(change)} Decrease MoM`);
              setIsIncVol(false);
            }
          });
      } catch (error) {
        console.error("Error fetching Reconciled Volume options:", error);
      }
    };

    const fetchR2RACreconciledValue = async () => {
      let allPreviousMonth = [];
      monthFilterData.forEach((item) => {
        if (item - 1 !== 0) allPreviousMonth.push(item - 1);
      });
      try {
        const response = await axios
          .post(
            `${API_BASE_URL}/api/R2R-ac-reconciled`,
            {
              selectedEntity: entityFilterData,
              selectedYear: yearFilterData,
              selectedMonth: monthFilterData,
              previousMonth: allPreviousMonth,
            },
            {
              headers: {
                // Authorization: `Bearer ${token}`,
                Authorization: "Basic YWRtaW4xOjEyMw==",
              },
            }
          )
          .then((response) => {
            const result = response.data;

            const currentValue = result.current_month_value || 0;
            const previousValue = result.previous_month_value || 0;

            setACreconciledValue(currentValue);

            const change = currentValue - previousValue;

            if (change === 0) {
              setChangeText("No Change MoM");
              setIsIncrease(false);
            } else if (change > 0) {
              setChangeText(`${change} Increase MoM`);
              setIsIncrease(true);
            } else {
              setChangeText(`${Math.abs(change)} Decrease MoM`);
              setIsIncrease(false);
            }
          });
      } catch (error) {
        console.error("Error fetching AC Reconciled Value options:", error);
      }
    };

    const fetchR2RUnreconciledValue = async () => {
      let allPreviousMonth = [];
      monthFilterData.forEach((item) => {
        if (item - 1 !== 0) allPreviousMonth.push(item - 1);
      });
      try {
        const response = await axios
          .post(
            `${API_BASE_URL}/api/R2R-unreconciled`,
            {
              selectedEntity: entityFilterData,
              selectedYear: yearFilterData,
              selectedMonth: monthFilterData,
              previousMonth: allPreviousMonth,
            },
            {
              headers: {
                // Authorization: `Bearer ${token}`,
                Authorization: "Basic YWRtaW4xOjEyMw==",
              },
            }
          )
          .then((response) => {
            const result = response.data;

            const currentValue = result.current_month_value || 0;
            const previousValue = result.previous_month_value || 0;

            setUnreconciledValue(currentValue);

            const change = currentValue - previousValue;

            if (change === 0) {
              setChangeUnText("No change");
              setIsIncdec(false);
            } else if (change > 0) {
              setChangeUnText(`${change} Cr`);
              setIsIncdec(true);
            } else {
              setChangeUnText(`${Math.abs(change)} Cr`);
              setIsIncdec(false);
            }
          });
      } catch (error) {
        console.error("Error fetching UnReconciled Value options:", error);
      }
    };

    const fetchR2RGritScore = async () => {
      try {
        const response = await axios.post(
          `${API_BASE_URL}/api/R2R-gritscore`,
          {
            selectedEntity: entityFilterData,
            selectedYear: yearFilterData,
            selectedMonth: monthFilterData,
          },
          {
            headers: {
              // Authorization: `Bearer ${token}`,
              Authorization: "Basic YWRtaW4xOjEyMw==",
            },
          }
        );

        const result = response.data?.grit || {};

        setGritData({
          grit_score: result.grit_score || 0,
          rank: result.rank || 0,
        });
      } catch (error) {
        console.error("Error fetching GRIT Score:", error);
      }
    };

    const fetchR2REPMScore = async () => {
      try {
        const response = await axios.post(
          `${API_BASE_URL}/api/R2R-epmscore`,
          {
            selectedEntity: entityFilterData,
            selectedYear: yearFilterData,
            selectedMonth: monthFilterData,
          },
          {
            headers: {
              Authorization: "Basic YWRtaW4xOjEyMw==",
            },
          }
        );

        const result = response.data?.epmscore || {};

        setEpmData({
          epm_score: result.epm_score || 0,
        });
      } catch (error) {
        console.error("Error fetching EPM Score:", error);
      }
    };

    const fetchR2RDisclosureScore = async () => {
      try {
        const response = await axios.post(
          `${API_BASE_URL}/api/R2R-disclosure`,
          {
            selectedEntity: entityFilterData,
            selectedYear: yearFilterData,
            selectedMonth: monthFilterData,
          },
          {
            headers: {
              Authorization: "Basic YWRtaW4xOjEyMw==",
            },
          }
        );

        const result = response.data?.disclosures || {};

        const delayedValue =
          typeof result.delayed === "string"
            ? parseFloat(result.delayed.replace("%", ""))
            : parseFloat(result.delayed) || 0;

        const onTimeValue =
          typeof result.on_time === "string"
            ? parseFloat(result.on_time.replace("%", ""))
            : parseFloat(result.on_time) || 0;

        setDisclosureData({
          delayed: delayedValue,
          on_time: onTimeValue,
        });
      } catch (error) {
        console.error("Error fetching Report/Disclosure Score:", error);
        setDisclosureData({ delayed: 0, on_time: 0 });
      }
    };

    const fetchUnreconVarianceData = async () => {
      try {
        const response = await axios.post(
          `${API_BASE_URL}/api/R2R-age-unreconvariance`,
          {
            selectedEntity: entityFilterData,
            selectedSubEntity: subEntityFilterData,
            selectedYear: yearFilterData,
            selectedMonth: monthFilterData,
          },
          {
            headers: {
              Authorization: "Basic YWRtaW4xOjEyMw==",
            },
          }
        );

        const result = response.data?.UnreconVar || [];

        if (result.length > 0) {
          const labels = result.map((item) => item.period);
          const data = result.map((item) => item.final_amount);

          const datasets = [
            {
              label: "Amount (In Cr)",
              data: data,
              backgroundColor: "#f4a300",
            },
          ];

          setAgedUnreconciledVarianceData({ labels, datasets });
        } else {
          setAgedUnreconciledVarianceData({ labels: [], datasets: [] });
        }
      } catch (error) {
        console.error("Error fetching Unreconciled Variance data:", error);
      }
    };

    const fetchAgeUnreconConsecutiveData = async () => {
      try {
        const response = await axios.post(
          `${API_BASE_URL}/api/R2R-age-unreconconsecutive`,
          {
            selectedEntity: entityFilterData,
            selectedYear: yearFilterData,
            selectedMonth: monthFilterData,
          },
          {
            headers: {
              Authorization: "Basic YWRtaW4xOjEyMw==",
            },
          }
        );

        let result = response.data?.AgedUnreconciledConsecutive;
        if (!Array.isArray(result)) result = [result].filter(Boolean);

        const desiredLabels = ["Q1", "Q2", "Q3", "Q4"];

        const dataMap = result.reduce((acc, item) => {
          acc[item.quarter?.toUpperCase().trim()] = {
            Unique: Number(item.Unique) || 0,
            Repeated: Number(item.Repeated) || 0,
          };
          return acc;
        }, {});

        const uniqueData = desiredLabels.map((label) => dataMap[label]?.Unique || 0);
        const repeatedData = desiredLabels.map((label) => dataMap[label]?.Repeated || 0);

        const datasets = [
          { label: "Unique", data: uniqueData, backgroundColor: "#2f78c4" },
          { label: "Repeated", data: repeatedData, backgroundColor: "#f4a300" },
        ];

        setAgeUnreconConsecutive({ labels: desiredLabels, datasets });

      } catch (error) {
        console.error(
          "Error fetching R2R Unreconciled Consecutive Data options:",
          error
        );
        setAgeUnreconConsecutive({
          labels: ["Q1", "Q2", "Q3", "Q4"],
          datasets: [
            { label: "Unique", data: [0, 0, 0, 0], backgroundColor: "#2f78c4" },
            { label: "Repeated", data: [0, 0, 0, 0], backgroundColor: "#f4a300" },
          ],
        });
      }
    };

    Promise.all([
      fetchGLCoverageData(),
      fetchAgeUnreconItemData(),
      fetchAgeUnreconMonthItemData(),
      fetchR2RAvgage(),
      fetchR2RReconciledVolume(),
      fetchR2RACreconciledValue(),
      fetchR2RUnreconciledValue(),
      fetchAgeUnreconConsecutiveData(),
      fetchUnreconVarianceData(),
      fetchR2RGritScore(),
      fetchR2REPMScore(),
      fetchR2RDisclosureScore(),
    ]).then(() => {
      setShowDashboard(true);
      setIsLoading(false);
    });
  };

  const handleReset = () => {
    setEntity(null);
    setYear(null);
    setSubEntity([]);
    setMonth([]);
    setWeek(WeekOptions[0]);
    setFilters({
      entityData: null,
      subEntityData: [],
      yearData: null,
      monthData: [],
      weekData: null,
    });
    setShowDashboard(false);
  };

  const fetchEntityOptions = async () => {
    try {
      const response = await axios
        .get(`${API_BASE_URL}/api/R2R-entity`, {
          headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: "Basic YWRtaW4xOjEyMw==",
          },
        })
        .then((response) => {
          const allEntities = response.data?.[0]?.all || [];
          setEntityOptions(allEntities);
        });
    } catch (error) {
      console.error("Error fetching R2R-entity options:", error);
    }
  };

  const fetchSubEntityOptions = async () => {
    try {
      const response = await axios
        .get(`${API_BASE_URL}/api/R2R-subEntity`, {
          headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: "Basic YWRtaW4xOjEyMw==",
          },
        })
        .then((response) => {
          const subEntities = response.data;
          setSubEntityOptions(subEntities);
        });
    } catch (error) {
      console.error("Error fetching R2R-Sub-Entity options:", error);
    }
  };

  const fetchYearOptions = async () => {
    try {
      const response = await axios
        .get(`${API_BASE_URL}/api/R2R-year`, {
          headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: "Basic YWRtaW4xOjEyMw==",
          },
        })
        .then((response) => {
          setYearOptions(response.data);
        });
    } catch (error) {
      console.error("Error fetching R2R-year options:", error);
    }
  };

  const fetchMonthOptions = async () => {
    try {
      const response = await axios
        .get(`${API_BASE_URL}/api/R2R-month`, {
          headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: "Basic YWRtaW4xOjEyMw==",
          },
        })
        .then((response) => {
          setMonthOptions(response.data);
        });
    } catch (error) {
      console.error("Error fetching R2R-month options:", error);
    }
  };

  useEffect(() => {
    fetchEntityOptions();
    fetchYearOptions();
    fetchMonthOptions();
    fetchSubEntityOptions();
  }, []);

  useEffect(() => {
    if (entityOptions.length && subEntityOptions.length && yearOptions.length && monthOptions.length) {
      if (filters.entityData?.value) {
        const ent = entityOptions.find(
          (opt) => opt.value === filters.entityData.value
        );
        if (ent) setEntity(ent);
      }

      if (filters.subEntityData && filters.subEntityData.length > 0) {
        const sub = subEntityOptions.filter((opt) =>
          filters.subEntityData.some((s) => s.value === opt.value)
        );
        if (sub.length > 0) setSubEntity(sub);
      }

      if (filters.yearData?.value) {
        const yr = yearOptions.find(
          (opt) => opt.value === filters.yearData.value
        );
        if (yr) setYear(yr);
      }

      if (filters.monthData && filters.monthData.length > 0) {
        const mon = monthOptions.filter((opt) =>
          filters.monthData.some((m) => m.value === opt.value)
        );
        if (mon.length > 0) setMonth(mon);
      }

      if (filters.entityData?.value) {
        setTimeout(() => {
          setHasApplied(true);
        }, 1000);
      }
    }
  }, [entityOptions, subEntityOptions, yearOptions, monthOptions]);

  useEffect(() => {
    if (hasApplied === true) {
      handleApply();
      setHasApplied(false);
    }
  }, [hasApplied]);

  const amberGradient = 'linear-gradient(135deg, #FBBF24 0%, #F97316 100%)';
  const paidOnTimeGradient = 'linear-gradient(135deg, #F43F5E 0%, #DB2777 100%)';
  const blueGradient = 'linear-gradient(135deg, #3B82F6 0%, #4F46E5 100%)';
  const indigoGradient = 'linear-gradient(135deg, #6366F1 0%, #7C3AED 100%)';
  const purpleGradient = 'linear-gradient(135deg, #8B5CF6 0%, #C026D3 100%)';
  const emeraldGradient = 'linear-gradient(135deg, #10B981 0%, #0D9488 100%)';

  return (
    <>
      <div className="row">
        <div className="col-md-12">
          <DomainTile
            title="Record-To-Report"
            showBackButton={false}
            mainPagePath="/Record-To-Report"
          />
        </div>
      </div>

      {/* Select Bar */}
      <div className={styles.filter_panel_container}>
        <div className={styles.filter_panel_row}>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>
              Entity<span style={{ color: "red" }}>*</span>
            </label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={entity}
                onChange={handleEntityChange}
                options={entityOptions}
                isSearchable={true}
              // isMulti={true}
              // closeMenuOnSelect={false}
              // styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Sub Entity</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={subEntity}
                onChange={handleSubEntityChange}
                options={subEntityOptions}
                isSearchable={true}
                isMulti={true}
                closeMenuOnSelect={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>
              Year<span style={{ color: "red" }}>*</span>
            </label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={year}
                onChange={handleYearChange}
                options={yearOptions}
                isSearchable={true}
              // isMulti={true}
              // closeMenuOnSelect={false}
              // styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Month</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={month}
                onChange={handleMonthChange}
                options={monthOptions}
                isSearchable={true}
                isMulti={true}
                closeMenuOnSelect={false}
                styles={customStyles}
              />
            </div>
          </div>
          {/* <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Week</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={week}
                onChange={setWeek}
                options={WeekOptions}
                isSearchable={true}
              />
            </div>
          </div> */}
          <div className="filter-panel-col action-buttons">
            <button onClick={handleApply} className="btn apply-btn">
              Apply
            </button>
            <button onClick={handleReset} className="btn reset-btn">
              Reset
            </button>
          </div>
        </div>
      </div>
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div className="text-center">
            <div
              className="spinner-border text-primary mb-3"
              role="status"
            ></div>
            <p
              className="mb-3"
              style={{ fontSize: "18px", fontWeight: "bold", color: "#0067ac" }}
            >
              Loading...
            </p>
          </div>
        </div>
      )}
      {showDashboard && (
        <>
          <div>
            {/* Title Row (Bank Reconciliation & GL Reconciliation Headers - remains the same) */}
            <div className="row">
              <div className="col-md-12 col-lg-6">
                <DetailedDomainTile
                  title="Bank Reconciliation"
                  showButton={true}
                  path="/Record-To-Report/Bank-Reconcilation"
                  detailState={filters}
                />
              </div>
              <div className="col-md-12 col-lg-6">
                <DetailedDomainTile
                  title="GL Reconciliation"
                  showButton={true}
                  path="/Record-To-Report/GL-Reconciliation"
                  detailState={filters}
                />
              </div>
            </div>
            <div className="row">
              {/* COLUMN 1 (Left - Bank Reconciliation) */}
              <div className="col-md-12 col-lg-6">
                <div className="row">
                  <div className="col-12 mb-2">
                    <div className="row d-flex align-items-stretch">
                      <div className="col-12 col-md-6 col-xl-6 d-flex flex-column ">
                        {/* Reconcilations Volume (Tile 1) */}
                        <div className="mb-3">
                          <R2RMiniStat
                            title="Reconcilations Volume"
                            value={reconciledVol}
                            changeText={changeVolText}
                            isIncrease={isIncVol}
                            showArrow={true}
                            icon={reconvolumne}
                          />
                        </div>
                        {/* Average Aged Unreconciled Items (Tile 2) */}
                        <div className="mb-0">
                          <R2RMiniStat
                            title="Average Aged Unreconciled Items"
                            value={`${avgAge} Days`}
                            changeText={changeAvgAgeText}
                            isIncrease={isIncAvgAge}
                            showArrow={true}
                            icon={ageunreconitems}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-6">
                        <DashboardSection
                          title="Aged Unreconciled Items-Month End"
                          disableDetailView={true}
                          detailPath=""
                             infoIcondata={"Manual CSV + SAP DATA"}
                        >
                          <RecordBarChart
                            labels={ageMonthLabel}
                            datasets={ageUnreconMonthData}
                            height={180}
                            showLegend={false}
                            barThickness={30}
                            hoverLabel={true}
                          />
                        </DashboardSection>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 mb-4">
                    <DashboardSection
                      title="Aged Unreconciled Items"
                      disableDetailView={true}
                      detailPath="/Record-To-Report/BankReconcilation"
                         infoIcondata={"Manual CSV + SAP DATA"}
                    >
                      <RecordToReportBarChart
                        labels={ageUnreconItemData.labels}
                        datasets={ageUnreconItemData.datasets}
                      />
                    </DashboardSection>
                  </div>
                </div>
              </div>
              {/* COLUMN 2 (Right - GL Reconciliation) */}
              <div className="col-md-12 col-lg-6">
                <div className="row">
                  <div className="col-12 mb-2">
                    <div className="row d-flex align-items-stretch">
                      <div className="col-12 col-md-6 col-xl-6 d-flex flex-column">
                        {/* A/C Reconciled (Tile 3) */}
                        <div className="mb-3">
                          <R2RMiniStat
                            title="A/C Reconciled"
                            value={acReconciledValues}
                            changeText={changeText}
                            isIncrease={isIncrease}
                            showArrow={true}
                            icon={reconciledimg}
                          />
                        </div>
                        {/* UnReconciled Value (Tile 4) */}
                        <div className="mb-0">
                          <R2RMiniStat
                            title="UnReconciled Value"
                            value={`${unReconciledValues} Cr`}
                            changeText={changeUnText}
                            isIncrease={isIncDec}
                            showArrow={true}
                            icon={unreconciledvalue}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-6">
                        <DashboardSection
                          title="GL Coverage"
                          disableDetailView={true}
                          detailPath=""
                             infoIcondata={"Manual CSV DATA"}
                        >
                          <RecordToReportPieChart
                            filedBy={filedBy}
                            filedAgainst={filedAgainst}
                            Labels={glLabels}
                          />
                        </DashboardSection>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 mb-4">
                    <DashboardSection
                      title="Unreconciled-Consecutive Quarter"
                      disableDetailView={true}
                      detailPath=""
                      infoIcondata={"Manual CSV DATA"}
                    >
                      <RecordToReportBarChart
                        labels={ageUnreconConsecutive.labels}
                        datasets={ageUnreconConsecutive.datasets}
                      />
                    </DashboardSection>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row d-flex flex-wrap mb-n5">
            {/* Intercompany Reconciliation Column (col-12 col-lg-8) */}
            <div className="col-12 col-lg-8 mb-4">
              <div className="row mb-1">
                <div className="col-12">
                  <DetailedDomainTile
                    title="Intercompany Reconciliation"
                    showButton={true}
                    path="/Record-To-Report/InterCompany-Reconciliation"
                    detailState={filters}
                    // infoIcondata={"Manual CSV + SAP DATA"}
                  />
                </div>
              </div>

              {/* 2. Aged Unreconciled Variance Chart */}
              <div className="row">
                <div className="col-12 d-flex justify-content-center align-items-center">
                  <div className={styles.chartContainer}>
                    <R2RLineChart
                      Heading="Aged Unreconciled Variance - ₹ Crores"
                      labels={agedUnreconciledVarianceData.labels}
                      datasets={agedUnreconciledVarianceData.datasets}
                      showLegend={false}
                      height="270px"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Period End Closing Column (col-12 col-lg-4) */}
            <div className="col-12 col-lg-4 mb-0">
              <div className="row mb-1">
                <div className="col-12">
                  <R2RDomainTile
                    title="Period End Closing"
                    showBackButton={false}
                  />
                </div>
              </div>

              <div className={styles.periodEndClosingBox}>
                <div className="row">
                  {/* GRIT Score */}
                  <div className="col-6">
                    <R2RTileComp
                      title="GRIT SCORE"
                      number={gritData.grit_score}
                      rank={gritData.rank}
                      gradient={amberGradient}
                    />
                  </div>

                  {/* EPM Adjustments */}
                  <div className="col-6">
                    <R2RTileComp
                      title="EPM ADJUSTMENTS"
                      number={epmData.epm_score}
                      gradient={blueGradient}
                    />
                  </div>
                </div>

                {/* 3. Reports/ Schedules/ Disclosures */}
                <div className="row mt-4">
                  <div className="col-12">
                    <DashboardSection
                      title="Reports/Disclosures"
                      disableDetailView={true}
                      detailPath=""
                      infoIcondata={"Manual CSV DATA"}
                    >
                      <ReportsStatusBarChart
                        labels={[""]}
                        datasets={[
                          {
                            label: "Delayed",
                            data: [disclosureData.delayed],
                            backgroundColor: "#dc3545",
                          },
                          {
                            label: "On Time",
                            data: [disclosureData.on_time],
                            backgroundColor: "#28a745",
                          },
                        ]}
                        title=""
                        isStacked={false}
                        height="95px"
                      />
                    </DashboardSection>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default RecordToReportMainDashboard;